/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-hot-toast';
import { FaUtensils, FaAngleDown } from 'react-icons/fa';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import {
  Modal,
  ModalFooter,
  ModalHeader,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import api from '~/services/api';
import { Form } from '@unform/web';
import {
  Button,
  Checkbox,
  Divider,
  IconChevronRight,
  IconChevronUp,
  IconInfoFilled,
  IconPlus,
  Input,
} from 'takeat-design-system-ui-kit';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '~/context/AuthContext';
import getValidationErrors from '~/services/getValidationErrors';
import * as Yup from 'yup';

import { Tabs } from 'ui-kit-takeat';
import CheckboxInput from '~/components/Form/Checkbox';
import ChooseKitchen from './ChooseKitchen';
import {
  Container,
  Card,
  Header,
  Content,
  ScreenTwo,
  ScreenOne,
  ButtonsArea,
  StyledTable,
  InputStyled,
  CheckboxInputStyled,
  ModalStyled,
  InputLine,
  KdsInfoArea,
  Footer,
  ViewArea,
  View,
  KitchenItem,
  ViewAreaTitle,
  ViewAreaSubtitle,
  KdsItems,
  ScreenThree,
  ScreenTitle,
  StepsContainer,
  StepsTitle,
  StepItem,
  StepTitle,
} from './styles';

function Kds() {
  const [kds, setKds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const { user } = useAuth();
  const CheckState = {
    On: 0,
    Off: 1,
    Partial: 2,
  };
  const [groupItems, setGroupItems] = useState(true);
  const [kdsNotifyWhatsapp, setKdsNotifyWhatsapp] = useState(false);
  const [kdsNotifySound, setKdsNotifySound] = useState(false);
  const [kdsAutoStart, setKdsAutoStart] = useState(false);
  const [modalCreateKitchen, setModalCreateKitchen] = useState(false);
  const [allChecked, setAllChecked] = useState(CheckState.Off);
  const [allComplementsChecked, setAllComplementsChecked] = useState(
    CheckState.Off
  );
  const [steps, setSteps] = useState(1);
  const formRef = useRef(null);
  const updateAll = useRef(false);

  const [activeTab, setActiveTab] = useState(0);
  const toggleModalCreateKitchen = useCallback(() => {
    if (!modalCreateKitchen) {
      setGroupItems(true);
      setKdsNotifyWhatsapp(false);
      setKdsNotifySound(false);
      setKdsAutoStart(false);
      setAllChecked(CheckState.Off);
      setAllComplementsChecked(CheckState.Off);
    }
    setModalCreateKitchen(!modalCreateKitchen);
  }, [modalCreateKitchen]);

  const [activeScreen, setActiveScreen] = useState(1);

  const [arrayCategories, setArrayCategories] = useState([]);

  const getCategories = useCallback(async () => {
    const response = await api.get('/restaurants/kds/product-categories/0');

    const categories = response.data;

    setArrayCategories(categories);
  }, []);

  const [arrayComplementCategories, setArrayComplementCategories] = useState(
    []
  );

  const getComplementCategories = useCallback(async () => {
    const response = await api.get('/restaurants/kds/complement-categories/0');

    const categories = response.data;

    setArrayComplementCategories(categories);
  }, []);

  useEffect(() => {
    if (modalCreateKitchen) {
      getCategories();
    }
  }, [getCategories, modalCreateKitchen]);

  useEffect(() => {
    getComplementCategories();
  }, [getComplementCategories, user, modalCreateKitchen]);

  const [categoryExpanded, setCategoryExpanded] = useState(null);

  function toggleExpand(id) {
    if (categoryExpanded === id) {
      setCategoryExpanded(null);
    } else {
      setCategoryExpanded(id);
    }
  }

  const [complementCategoryExpanded, setComplementCategoryExpanded] =
    useState(null);

  function toggleExpandComplementCategory(id) {
    if (complementCategoryExpanded === id) {
      setComplementCategoryExpanded(null);
    } else {
      setComplementCategoryExpanded(id);
    }
  }

  useEffect(() => {
    if (!updateAll.current) {
      return;
    }

    updateAll.current = false;

    if (allChecked === CheckState.On) {
      setArrayCategories((categs) => {
        for (const item of categs) {
          item.checked = true;
          for (const product of item.products) {
            product.checked = true;
          }
        }

        return categs.slice();
      });
    } else if (allChecked === CheckState.Off) {
      setArrayCategories((categs) => {
        for (const item of categs) {
          item.checked = false;
          for (const product of item.products) {
            product.checked = false;
          }
        }

        return categs.slice();
      });
    }
  }, [allChecked]);

  useEffect(() => {
    if (!updateAll.current) {
      return;
    }

    updateAll.current = false;

    if (allComplementsChecked === CheckState.On) {
      setArrayComplementCategories((categs) => {
        for (const item of categs) {
          item.checked = true;
          for (const complement of item.complements) {
            complement.checked = true;
          }
        }

        return categs.slice();
      });
    } else if (allComplementsChecked === CheckState.Off) {
      setArrayComplementCategories((categs) => {
        for (const item of categs) {
          item.checked = false;
          for (const complement of item.complements) {
            complement.checked = false;
          }
        }

        return categs.slice();
      });
    }
  }, [allComplementsChecked]);

  useEffect(() => {
    const checkedCount = arrayCategories.reduce(
      (acc, item) => (item.checked ? acc + 1 : acc),
      0
    );

    if (checkedCount === 0) {
      setAllChecked(CheckState.Off);
    } else if (checkedCount === arrayCategories.length) {
      setAllChecked(CheckState.On);
    } else {
      setAllChecked(CheckState.Partial);
    }
  }, [arrayCategories]);

  useEffect(() => {
    const checkedCount = arrayComplementCategories.reduce(
      (acc, item) => (item.checked ? acc + 1 : acc),
      0
    );

    if (checkedCount === 0) {
      setAllComplementsChecked(CheckState.Off);
    } else if (checkedCount === arrayComplementCategories.length) {
      setAllComplementsChecked(CheckState.On);
    } else {
      setAllComplementsChecked(CheckState.Partial);
    }
  }, [arrayComplementCategories]);

  const getKds = useCallback(async () => {
    const response = await api.get('/restaurants/kds');
    setIsLoading(false);
    setKds(response.data);
  }, []);

  useEffect(() => {
    try {
      getKds();
    } catch (error) {
      console.log(error.message);
    }
  }, [getKds]);

  const [permission, setPermission] = useState();
  const [loadingPage, setLoadingPage] = useState(false);

  const validateUser = useCallback(async () => {
    setLoadingPage(true);
    try {
      const response = await api.get(
        `/restaurants/users/role-permission/${'OperationKDS'}`
      );
      setLoadingPage(false);
      const { can_read } = response.data.OperationKDS;

      setPermission(can_read);
    } catch (error) {
      // setPermission(false);
      // if (error?.response?.data?.payload?.user_access === 'pdv') {
      //   window.location.href = '/operation';
      // }
      setLoadingPage(false);
      toast.error('Erro ao solicitar acesso');
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  const handleOpenInNewTab = () => {
    const url = history.createHref({ pathname: '/kds-password' });
    window.open(url, '_blank');
  };

  const [kdsName, setKdsName] = useState(null);
  const [kdsAverageTime, setKdsAverageTime] = useState(null);
  const [stepsToSubmit, setStepsToSubmit] = useState([]);

  const handleDeleteStates = useCallback(() => {
    setKdsAutoStart(false);
    setKdsNotifySound(false);
    setKdsName(null);
    setSteps(1);
    setGroupItems(false);
    setKdsNotifyWhatsapp(false);
    setAllChecked(CheckState.Off);
    setAllComplementsChecked(CheckState.Off);
    setActiveScreen(1);
    setStepsToSubmit([]);
  }, [CheckState.Off]);

  // criar kds
  const handleSubmit = useCallback(async () => {
    if (activeScreen === 1) {
      if (!kdsName) {
        toast.error('Preencha o nome do KDS');
        return;
      }

      if (!kdsAverageTime && steps === 1) {
        toast.error('Preencha o tempo médio');
        return;
      }
      try {
        setActiveScreen(2);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRef.current) {
            formRef.current.setErrors(errors);
          }
        }
      }
    } else {
      // Obs.: Para reduzir o tamanho do body, é usado esse formato no lugar de objetos
      const productsMinimalInfo = arrayCategories
        .filter((item) => item.checked && item.products.length > 0)
        .map((pc) => {
          return [
            pc.product_category_id,
            !!pc.checked,
            pc.average_time || 0,
            pc.products.map((p) => {
              return [p.product_id, !!p.checked, p.average_time || 0];
            }),
          ];
        });

      const complementsMinimalInfo = arrayComplementCategories
        .filter((item) => item.checked && item.complements.length > 0)
        .map((cc) => {
          return [
            cc.complement_category_id,
            !!cc.checked,
            cc.average_time || 0,
            cc.complements.map((c) => {
              return [c.complement_id, !!c.checked, c.average_time || 0];
            }),
          ];
        });

      const stepsToSubmitFormatted = stepsToSubmit.map((item) => {
        const itemFormatted = {
          name: item.name,
          average_time: Number(item.average_time),
          notify_sound: item.notify_sound,
          auto_start: item.auto_start,
        };

        return itemFormatted;
      });

      try {
        await api.post('restaurants/kds', {
          is_operational: steps > 1,
          average_time: steps > 1 ? 0 : kdsAverageTime,
          group_items: groupItems,
          notify_whatsapp: kdsNotifyWhatsapp,
          notify_sound: kdsNotifySound,
          auto_start: kdsAutoStart,
          name: kdsName,
          view_mode: 4,
          kds_steps: steps > 1 ? stepsToSubmitFormatted : [],
          product_categories: productsMinimalInfo,
          complement_categories: complementsMinimalInfo,
        });

        toast.success('Tela cadastrada com sucesso');
        handleDeleteStates();
        toggleModalCreateKitchen();
        getKds();
      } catch (error) {
        toast.error('Erro ao cadastrar tela');
      }
    }
  }, [
    arrayCategories,
    arrayComplementCategories,
    toggleModalCreateKitchen,
    kdsNotifyWhatsapp,
    getKds,
    activeScreen,
    kdsAverageTime,
    kdsName,
    kdsAutoStart,
    kdsNotifySound,
    groupItems,
    stepsToSubmit,
    steps,
    handleDeleteStates,
  ]);

  function handleChangeCategoryPreparationTime(id, value) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.product_category_id === id
      );

      newArray[categoyFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeComplementCategoryPreparationTime(id, value) {
    setArrayComplementCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.complement_category_id === id
      );

      newArray[categoyFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeProductPreparationTime(category_id, product_id, value) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.product_category_id === category_id
      );

      const productFind = newArray[categoyFind].products.findIndex(
        (prod) => prod.product_id === product_id
      );

      newArray[categoyFind].products[productFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeComplementPreparationTime(
    category_id,
    complement_id,
    value
  ) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.complement_category_id === category_id
      );

      const complementFind = newArray[categoyFind].complements.findIndex(
        (comp) => comp.complement_id === complement_id
      );

      newArray[categoyFind].complements[complementFind].average_time = value;

      return [...newArray];
    });
  }

  function handleGetAllProductsChecked(id) {
    const categoryFind = arrayCategories.find(
      (category) => category.product_category_id === id
    );

    const allCheckedItems = categoryFind?.products.every(
      (item) => item.checked
    );

    return allCheckedItems;
  }

  function handleGetAllComplementsChecked(id) {
    const categoryFind = arrayComplementCategories.find(
      (category) => category.complement_category_id === id
    );

    const allCheckedItems = categoryFind?.complements.every(
      (item) => item.checked
    );

    return allCheckedItems;
  }

  function handleCheckComplement(category_id, complement_id, old_status) {
    setArrayComplementCategories((categs) => {
      const found = categs.find(
        (cat) => cat.complement_category_id === category_id
      );

      if (!found || !found.complements) {
        return categs;
      }

      const complementeFound = found.complements.find(
        (comp) => comp.complement_id === complement_id
      );

      if (!complementeFound) {
        return categs;
      }

      complementeFound.checked = !old_status;

      const checkedCount = found.complements.reduce(
        (acc, comp) => (comp.checked ? acc + 1 : acc),
        0
      );

      found.checked = checkedCount !== 0;

      return categs.slice();
    });
  }

  function handleCheckCategory(id, old_status) {
    setArrayCategories((categs) => {
      const found = categs.find((cat) => cat.product_category_id === id);

      if (!found) {
        return categs;
      }

      if (old_status) {
        found.checked = false;

        for (const product of found.products) {
          product.checked = false;
        }
      } else {
        found.checked = true;

        for (const product of found.products) {
          product.checked = true;
        }
      }

      return categs.slice();
    });
  }

  function handleCheckComplementCategory(id, old_status) {
    setArrayComplementCategories((categs) => {
      const found = categs.find((cat) => cat.complement_category_id === id);

      if (!found) {
        return categs;
      }

      if (old_status) {
        found.checked = false;

        for (const complement of found.complements) {
          complement.checked = false;
        }
      } else {
        found.checked = true;

        for (const complement of found.complements) {
          complement.checked = true;
        }
      }

      return categs.slice();
    });
  }

  function handleCheckProduct(category_id, product_id, old_status) {
    setArrayCategories((categs) => {
      const found = categs.find(
        (cat) => cat.product_category_id === category_id
      );

      if (!found || !found.products) {
        return categs;
      }

      const productFound = found.products.find(
        (prod) => prod.product_id === product_id
      );

      if (!productFound) {
        return categs;
      }

      productFound.checked = !old_status;

      const checkedCount = found.products.reduce(
        (acc, prod) => (prod.checked ? acc + 1 : acc),
        0
      );

      found.checked = checkedCount !== 0;

      return categs.slice();
    });
  }

  function handleSetSteps(id, key, value) {
    setStepsToSubmit((prevSteps) => {
      const existingIndex = prevSteps.findIndex((step) => step.id === id);

      if (existingIndex !== -1) {
        const updatedSteps = [...prevSteps];
        updatedSteps[existingIndex] = {
          ...updatedSteps[existingIndex],
          [key]: value,
        };
        return updatedSteps;
      }
      return [
        ...prevSteps,
        { id, auto_start: false, notify_sound: false, [key]: value },
      ];
    });
  }

  const [confirmModalClose, setConfirmModalClose] = useState(false);

  function toggleConfirmModalClose() {
    setConfirmModalClose(!confirmModalClose);
  }

  const toggle = () => {
    if (modalCreateKitchen) {
      toggleConfirmModalClose();
    }
  };

  return !permission ? (
    <Container>
      <PermissionErrorContainer loading={loadingPage} />
    </Container>
  ) : isLoading ? (
    <Container>
      <Header>
        <h2>KDS</h2>
        {kds && kds.length > 0 && user.id === 2 && (
          <Button onClick={handleOpenInNewTab}>Tela de senhas</Button>
        )}
      </Header>
      <Card>
        <Content>
          <p>Carregando ...</p>
        </Content>
      </Card>
    </Container>
  ) : (
    <Container>
      <Header>
        <h2 style={{ fontSize: 20 }}>Tela KDS</h2>
        <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {kds && kds.length > 0 && user.id === 2 && (
            <Button onClick={handleOpenInNewTab}>Tela de senhas</Button>
          )}
          <Button onClick={toggleModalCreateKitchen} icon={<IconPlus />}>
            Criar KDS
          </Button>
        </span>
      </Header>
      {kds && kds.length > 0 ? (
        <ChooseKitchen kds={kds} getKds={getKds} />
      ) : (
        <Card>
          <Content>
            <FaUtensils size={44} />
            <p style={{ fontWeight: 'bold', marginTop: 20 }}>
              Você não possui KDS configurado ainda...
            </p>
            <p style={{ marginBottom: 20 }}>
              Clique no botão “Criar KDS” para começar.
            </p>
            <Button onClick={() => toggleModalCreateKitchen()}>
              Adicionar KDS
            </Button>
          </Content>
        </Card>
      )}

      <ModalStyled
        toggle={toggle}
        isOpen={modalCreateKitchen}
        onClosed={() => {
          handleDeleteStates();
        }}
      >
        <Form onSubmit={handleSubmit} ref={formRef}>
          <ScreenOne active={activeScreen}>
            <InputLine>
              <span
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <Input
                  label="Nome do KDS"
                  style={{ width: '100%' }}
                  onChange={(e) => setKdsName(e.target.value)}
                  info={
                    <span
                      style={{
                        display: 'flex',
                        width: 376,
                        marginTop: 4,
                        alignItems: 'center',
                      }}
                    >
                      <IconInfoFilled />
                      <span style={{ width: 376 }}>Exemplo: Praça Pizza</span>
                    </span>
                  }
                />
              </span>
              {(user.plan === 'PRO' || user.plan === 'ENTERPRISE') && (
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  <Input
                    label="Quantidade de etapas"
                    style={{ width: '100%' }}
                    type="number"
                    onChange={(e) => setSteps(Number(e.target.value))}
                    info={
                      <span
                        style={{
                          display: 'flex',
                          width: 376,
                          marginTop: 24,
                          alignItems: 'flex-start',
                        }}
                      >
                        <IconInfoFilled />
                        <span style={{ width: 376 }}>
                          Ao inserir mais de uma etapa, o sistema criará
                          automaticamente uma linha de produção. Você precisará
                          configurar cada etapa individualmente.
                        </span>
                      </span>
                    }
                  />
                </span>
              )}
            </InputLine>
            <Divider style={{ marginTop: 42 }} />
            {steps > 1 ? (
              <KdsInfoArea>
                <InputLine style={{ alignItems: 'flex-start', marginTop: 16 }}>
                  <Checkbox
                    name="group_items"
                    disabled={kdsNotifyWhatsapp}
                    label="Agrupar os itens do pedido"
                    checked={groupItems}
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        setGroupItems(!groupItems);
                      } else {
                        setGroupItems(true);
                      }
                    }}
                    description="Se desmarcado, será exibido um item por vez"
                  />
                  <Checkbox
                    value={kdsNotifyWhatsapp}
                    label="Notificação por whatsapp"
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        updateAll.current = true;

                        setGroupItems(true);
                        setAllChecked(CheckState.On);
                      }

                      setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                    }}
                    containerStyles={{ width: '38%' }}
                    description="O cliente será notificado via WhatsApp assim que a comanda for finalizada."
                  />
                  {/* 
                  <Checkbox
                    value={kdsNotifyWhatsapp}
                    label="Finalização de Pedidos KDS despacha no delivery"
                    containerStyles={{ width: '61%' }}
                    labelStyles={{ width: 392 }}
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        updateAll.current = true;
                        setGroupItems(true);
                        setAllChecked(CheckState.On);
                      }

                      setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                    }}
                    description="Habilite esta opção para permitir que os pedidos finalizados no KDS sejam despachados no delivery."
                  /> */}
                </InputLine>
                <ViewArea>
                  <ViewAreaTitle>Modo de visualização da etapa</ViewAreaTitle>
                  <ViewAreaSubtitle>
                    Veja como vai ficar a ordem das etapas do seu KDS
                    Operacional.
                  </ViewAreaSubtitle>
                  <View>
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gapp: 10,
                      }}
                    >
                      <IconChevronUp /> {kdsName || 'Etapas'}
                    </p>
                    <KdsItems>
                      {Array.from({ length: steps }).map((_, index) => (
                        <>
                          <KitchenItem
                            key={index}
                            style={{ background: '#01AFFF' }}
                          >
                            <p style={{ textAlign: 'center' }}>
                              Etapa {index + 1}
                            </p>
                          </KitchenItem>
                          {index !== steps - 1 && <IconChevronRight />}
                        </>
                      ))}
                    </KdsItems>
                  </View>
                </ViewArea>
              </KdsInfoArea>
            ) : (
              <KdsInfoArea>
                <InputLine style={{ alignItems: 'flex-start', width: 880 }}>
                  <Checkbox
                    name="group_items"
                    disabled={kdsNotifyWhatsapp}
                    label="Agrupar os itens do pedido"
                    checked={groupItems}
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        setGroupItems(!groupItems);
                      } else {
                        setGroupItems(true);
                      }
                    }}
                    description="Se desmarcado, será exibido um item por vez"
                  />

                  <Checkbox
                    name="notify_sound"
                    value={kdsNotifySound}
                    onChange={() => {
                      setKdsNotifySound(!kdsNotifySound);
                    }}
                    label="Ativar som ao chegar novo pedido."
                    description=""
                  />

                  <Checkbox
                    name="auto_start"
                    value={kdsAutoStart}
                    onChange={() => {
                      setKdsAutoStart(!kdsAutoStart);
                    }}
                    label="Aceitar pedidos automaticamente."
                  />
                </InputLine>
                <InputLine style={{ alignItems: 'flex-start', marginTop: 16 }}>
                  <Checkbox
                    value={kdsNotifyWhatsapp}
                    label="Notificação por whatsapp"
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        updateAll.current = true;

                        setGroupItems(true);
                        setAllChecked(CheckState.On);
                      }

                      setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                    }}
                    containerStyles={{ width: '38%' }}
                    description="O cliente será notificado via WhatsApp assim que a comanda for finalizada."
                  />

                  {/* <Checkbox
                    value={kdsNotifyWhatsapp}
                    label="Finalização de Pedidos KDS despacha no delivery"
                    containerStyles={{ width: '61%' }}
                    labelStyles={{ width: 392 }}
                    onChange={() => {
                      if (!kdsNotifyWhatsapp) {
                        updateAll.current = true;

                        setGroupItems(true);
                        setAllChecked(CheckState.On);
                      }

                      setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                    }}
                    description="Habilite esta opção para permitir que os pedidos finalizados no KDS sejam despachados no delivery."
                  /> */}
                </InputLine>

                <Input
                  label="Tempo médio (Em minutos)"
                  containerStyles={{ marginTop: 16 }}
                  onChange={(e) => {
                    setKdsAverageTime(e.target.value);
                  }}
                  info={
                    <span style={{ display: 'flex', marginTop: 20 }}>
                      <IconInfoFilled />
                      <span>
                        Tempo médio de preparação dos pratos. Caso algum prato
                        tenha tempo específico, basta personalizar na próxima
                        etapa.
                      </span>
                    </span>
                  }
                />
                <ViewArea style={{ marginTop: 38 }}>
                  <ViewAreaTitle>Modo de visualização da etapa</ViewAreaTitle>
                  <ViewAreaSubtitle>
                    Veja como vai ficar seu KDS
                  </ViewAreaSubtitle>
                  <View>
                    <p>KDS Tradicional</p>
                    <KitchenItem>
                      <p style={{ textAlign: 'center' }}>
                        {kdsName || 'Praça Pizza'}
                      </p>
                    </KitchenItem>
                  </View>
                </ViewArea>
              </KdsInfoArea>
            )}
          </ScreenOne>

          <ScreenTwo active={activeScreen}>
            {steps === 1 ? (
              <Row>
                <ScreenTitle>Tempo Personalizado</ScreenTitle>
                <p style={{ fontSize: 14 }}>
                  Personalize o tempo de preparo para itens específicos. Essa
                  etapa é opcional. Caso não seja definido será considerado a
                  tempo médio definido na etapa anterior.
                </p>
              </Row>
            ) : (
              <ScreenTitle>Seleção de items</ScreenTitle>
            )}

            <Tabs
              containerStyles={{ marginTop: 10 }}
              tabs={['Produtos', 'Complementos']}
              selected={activeTab}
              onChangeTab={(e) => setActiveTab(e)}
              mediaQueries={[
                {
                  maxWidth: 1024,
                  styles: 'font-size: 12px; padding: 0 5px;',
                },
              ]}
              tabSelectedStyles={{
                borderBottom: '2px solid red',
                borderRadius: 0,
              }}
              tabStyles={{
                borderBottom: '2px solid transparent',
                boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.1)',
              }}
            />

            <TabContent activeTab={activeTab} style={{ paddingBottom: 60 }}>
              <TabPane tabId={0}>
                <StyledTable>
                  <thead>
                    <tr>
                      <th>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#6c6c6c',
                          }}
                        >
                          {' '}
                          <CheckboxInputStyled
                            allChecksChecked={allChecked === CheckState.Partial}
                          >
                            <input
                              name="all_selected"
                              checked={allChecked !== CheckState.Off}
                              onChange={(e) => {
                                updateAll.current = true;

                                if (allChecked === CheckState.On) {
                                  setAllChecked(CheckState.Off);
                                } else {
                                  setAllChecked(CheckState.On);
                                }
                              }}
                              type="checkbox"
                            />
                          </CheckboxInputStyled>
                          Todos os itens
                        </span>
                      </th>
                      {steps === 1 && <th>Tempo de preparo</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {arrayCategories.map((category) => (
                      <React.Fragment key={category?.product_category_id}>
                        <tr>
                          <td>
                            {' '}
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#6c6c6c',
                                fontWeight: 'bold',
                              }}
                            >
                              <FaAngleDown
                                size={16}
                                onClick={() => {
                                  toggleExpand(category?.product_category_id);
                                }}
                                cursor="pointer"
                                style={{
                                  transition: 'all 0.2s',
                                  transform:
                                    categoryExpanded ===
                                    category?.product_category_id
                                      ? 'rotate(-90deg)'
                                      : 'rotate(0)',
                                  marginLeft: 22,
                                  marginRight: 10,
                                }}
                              />
                              <CheckboxInputStyled
                                allChecksChecked={
                                  !handleGetAllProductsChecked(
                                    category?.product_category_id
                                  )
                                }
                              >
                                <input
                                  defaultChecked={category?.checked}
                                  name={category?.name}
                                  key={category?.checked}
                                  value={category?.checked}
                                  type="checkbox"
                                  onClick={() => {
                                    handleCheckCategory(
                                      category?.product_category_id,
                                      category?.checked
                                    );
                                  }}
                                />
                              </CheckboxInputStyled>

                              {category?.name}
                            </span>
                          </td>
                          {steps === 1 && (
                            <td>
                              {' '}
                              <InputStyled
                                type="number"
                                defaultValue={category?.average_time}
                                onChange={(e) =>
                                  handleChangeCategoryPreparationTime(
                                    category?.product_category_id,
                                    e.target.value
                                  )
                                }
                              />{' '}
                              min
                            </td>
                          )}
                        </tr>

                        {category?.products &&
                          category?.products.map((product) => (
                            <tr
                              style={{
                                display:
                                  categoryExpanded !==
                                    category.product_category_id && 'none',
                              }}
                            >
                              <td style={{ border: 'none' }}>
                                {' '}
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#6c6c6c',
                                    paddingLeft: 55,
                                  }}
                                >
                                  <CheckboxInput
                                    defaultChecked={product.checked}
                                    name={product.name}
                                    key={product.checked}
                                    value={product.checked}
                                    disabled={kdsNotifyWhatsapp}
                                    onClick={() =>
                                      handleCheckProduct(
                                        category.product_category_id,
                                        product.product_id,
                                        product.checked
                                      )
                                    }
                                  />{' '}
                                  {product.name}
                                </span>
                              </td>
                              {steps === 1 && (
                                <td style={{ border: 'none' }}>
                                  <InputStyled
                                    defaultValue={product.average_time}
                                    onChange={(e) =>
                                      handleChangeProductPreparationTime(
                                        category.product_category_id,
                                        product.product_id,
                                        e.target.value
                                      )
                                    }
                                    type="number"
                                  />{' '}
                                  min
                                </td>
                              )}
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </StyledTable>
              </TabPane>
              <TabPane tabId={1}>
                <StyledTable>
                  <thead>
                    <tr>
                      <th>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#6c6c6c',
                          }}
                        >
                          {' '}
                          <CheckboxInputStyled
                            allChecksChecked={
                              allComplementsChecked === CheckState.Partial
                            }
                          >
                            <input
                              name="all_selected"
                              checked={allComplementsChecked !== CheckState.Off}
                              onChange={(e) => {
                                updateAll.current = true;

                                if (allComplementsChecked === CheckState.On) {
                                  setAllComplementsChecked(CheckState.Off);
                                } else {
                                  setAllComplementsChecked(CheckState.On);
                                }
                              }}
                              type="checkbox"
                            />
                          </CheckboxInputStyled>
                          Todos os itens
                        </span>
                      </th>
                      {steps === 1 && <th>Tempo de preparo</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {arrayComplementCategories.map((category) => (
                      <React.Fragment key={category?.complement_category_id}>
                        <tr>
                          <td>
                            {' '}
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#6c6c6c',
                                fontWeight: 'bold',
                              }}
                            >
                              <FaAngleDown
                                size={16}
                                onClick={() => {
                                  toggleExpandComplementCategory(
                                    category?.complement_category_id
                                  );
                                }}
                                cursor="pointer"
                                style={{
                                  transition: 'all 0.2s',
                                  transform:
                                    complementCategoryExpanded ===
                                    category?.complement_category_id
                                      ? 'rotate(-90deg)'
                                      : 'rotate(0)',
                                  marginLeft: 22,
                                  marginRight: 10,
                                }}
                              />
                              <CheckboxInputStyled
                                allChecksChecked={
                                  !handleGetAllComplementsChecked(
                                    category?.complement_category_id
                                  )
                                }
                              >
                                <input
                                  defaultChecked={category?.checked}
                                  name={category?.name}
                                  key={category?.checked}
                                  value={category?.checked}
                                  type="checkbox"
                                  onClick={() => {
                                    handleCheckComplementCategory(
                                      category?.complement_category_id,
                                      category?.checked
                                    );
                                  }}
                                />
                              </CheckboxInputStyled>

                              {category?.name}
                            </span>
                          </td>
                          {steps === 1 && (
                            <td>
                              {' '}
                              <InputStyled
                                type="number"
                                defaultValue={category?.average_time}
                                onChange={(e) =>
                                  handleChangeComplementCategoryPreparationTime(
                                    category?.complement_category_id,
                                    e.target.value
                                  )
                                }
                              />{' '}
                              min
                            </td>
                          )}
                        </tr>

                        {category?.complements &&
                          category?.complements.map((complement) => (
                            <tr
                              style={{
                                display:
                                  complementCategoryExpanded !==
                                    category.complement_category_id && 'none',
                              }}
                            >
                              <td style={{ border: 'none' }}>
                                {' '}
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#6c6c6c',
                                    paddingLeft: 55,
                                  }}
                                >
                                  <CheckboxInput
                                    defaultChecked={complement.checked}
                                    name={complement.name}
                                    key={complement.checked}
                                    value={complement.checked}
                                    disabled={kdsNotifyWhatsapp}
                                    onClick={() =>
                                      handleCheckComplement(
                                        category.complement_category_id,
                                        complement.complement_id,
                                        complement.checked
                                      )
                                    }
                                  />{' '}
                                  {complement.name}
                                </span>
                              </td>
                              {steps === 1 && (
                                <td style={{ border: 'none' }}>
                                  <InputStyled
                                    defaultValue={complement.average_time}
                                    onChange={(e) =>
                                      handleChangeComplementPreparationTime(
                                        category.complement_category_id,
                                        complement.complement_id,
                                        e.target.value
                                      )
                                    }
                                    type="number"
                                  />
                                  min
                                </td>
                              )}
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </StyledTable>
              </TabPane>
            </TabContent>
          </ScreenTwo>
          <ScreenThree active={activeScreen}>
            <ScreenTitle>Configurações das etapas</ScreenTitle>
            <StepsContainer>
              {Array.from({ length: steps }).map((step, index) => (
                <StepItem key={index}>
                  <InputLine>
                    <Input
                      type="text"
                      placeholder="Nome da etapa"
                      label={`Nome da etapa ${index + 1}`}
                      style={{ width: '100%' }}
                      info={
                        <span
                          style={{
                            display: 'flex',
                            width: 376,
                            alignItems: 'center',
                            marginTop: 8,
                          }}
                        >
                          <IconInfoFilled />
                          <span style={{ width: 376 }}>
                            Dê um nome para a etapa. Exemplo: Massa.
                          </span>
                        </span>
                      }
                      onChange={(e) => {
                        handleSetSteps(index, 'name', e.target.value);
                      }}
                    />
                    <Input
                      type="number"
                      placeholder="Tempo de preparo"
                      label="Tempo de preparo da etapa"
                      style={{ width: '100%' }}
                      info={
                        <span
                          style={{
                            display: 'flex',
                            width: 376,
                            alignItems: 'flex-start',
                            marginTop: 16,
                          }}
                        >
                          <IconInfoFilled />
                          <span style={{ width: 376 }}>
                            Caso algum item tenha tempo específico, basta
                            personalizar na próxima etapa.
                          </span>
                        </span>
                      }
                      onChange={(e) => {
                        handleSetSteps(index, 'average_time', e.target.value);
                      }}
                    />
                  </InputLine>
                  <InputLine
                    style={{
                      alignItems: 'flex-start',
                      width: 880,
                      marginTop: 32,
                    }}
                  >
                    <Checkbox
                      name="notify_sound"
                      onChange={(e) => {
                        handleSetSteps(index, 'notify_sound', e.target.checked);
                      }}
                      label="Ativar som ao chegar novo pedido."
                      description=""
                    />

                    <Checkbox
                      name="auto_start"
                      value={kdsAutoStart}
                      onChange={(e) => {
                        handleSetSteps(index, 'auto_start', e.target.checked);
                      }}
                      label="Aceitar pedidos automaticamente."
                    />
                  </InputLine>
                  <Divider style={{ marginTop: 16 }} />
                </StepItem>
              ))}
            </StepsContainer>
          </ScreenThree>

          <Footer>
            <Divider />
            <ButtonsArea>
              <Button
                onClick={() => {
                  toggleModalCreateKitchen();
                }}
                type="button"
              >
                Cancelar
              </Button>

              {activeScreen === 1 && (
                <Button
                  customColor="#2EC9B7"
                  type="submit"
                  // onClick={() => {
                  //   setActiveScreen(2);
                  // }}
                >
                  Próximo
                </Button>
              )}

              {activeScreen === 2 && steps === 1 && (
                <div style={{ display: 'flex' }}>
                  <Button
                    onClick={() => {
                      setActiveScreen(1);
                    }}
                    variant="outlined"
                  >
                    Voltar
                  </Button>
                  <Button
                    customColor="#2EC9B7"
                    type="submit"
                    style={{ marginLeft: 8 }}
                  >
                    Salvar
                  </Button>
                </div>
              )}

              {activeScreen === 2 && steps > 1 && (
                <div style={{ display: 'flex' }}>
                  <Button
                    onClick={() => {
                      setActiveScreen(1);
                    }}
                    variant="outlined"
                  >
                    Voltar
                  </Button>
                  <Button
                    customColor="#2EC9B7"
                    type="button"
                    onClick={() => {
                      setActiveScreen(3);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    Próximo
                  </Button>
                </div>
              )}

              {activeScreen === 3 && (
                <div style={{ display: 'flex' }}>
                  <Button
                    onClick={() => {
                      setActiveScreen(2);
                    }}
                    variant="outlined"
                  >
                    Voltar
                  </Button>
                  <Button
                    customColor="#2EC9B7"
                    type="submit"
                    style={{ marginLeft: 8 }}
                  >
                    Salvar
                  </Button>
                </div>
              )}
            </ButtonsArea>
          </Footer>
        </Form>
      </ModalStyled>

      <Modal
        isOpen={confirmModalClose}
        toggle={() => {
          setConfirmModalClose(false);
        }}
      >
        <ModalHeader>
          <h3 style={{ fontSize: 18 }}>
            Seus dados preenchidos serão perdidos ao fechar o modal.
          </h3>
        </ModalHeader>

        <ModalFooter>
          <Button onClick={() => setConfirmModalClose(false)}>
            Não fechar
          </Button>
          <Button
            onClick={() => {
              setModalCreateKitchen(false);
              setConfirmModalClose(false);
            }}
            customColor="#2EC9B7"
          >
            Fechar mesmo assim
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default Kds;